<template>
    <div class="content3d--area relative" style="z-index:2; overflow:hidden;">
        <div style="position:absolute; top:0; left:50%; width:40px; height:20px; margin-left:-20px;">
            <img :src="Arrow" />
        </div>

        <div class="b-container relative" style="padding-top:60px; padding-bottom:60px;">
            <div
                style="position:absolute; bottom:-310px; left:0; width:620px; height:620px; margin-left:-620px; opacity:.5;">
                <img :src="Circle" />
            </div>

            <div
                style="position:absolute; top:-160px; right:0; width:780px; height:780px; margin-right:-780px; opacity:.5;">
                <img :src="Circle" style="width:100%; height:100%;" />
            </div>

            <div class="column v-center center mb-xxl">
                <div class="row">
                    <div class="ml-xxl  h1" style=" color: #ff3355;">
                       应用场景
                    </div>
                   <div class="relative ml-md" style="width:84px; height:84px;">
                       <img :src="PlusRedIcon" style="width:84px; height:84px; position:absolute; top:-40px; left:-30px;" />
                   </div>
                </div>
              <!--  <div class="t3" style="text-transform: uppercase; letter-spacing:.1em; opacity:.5;">
                    Hardware facilities
                </div> -->
            </div>

            <!-- SWIPER START -->
            <div class="relative swiper-container-wrap mb-lg" id="content3d-swiper-wrap">
                <div v-show="paginationBulletsLength !== 1" class="swiper-prev column center v-start">
                    <img :src="IconPrev" style="display:block; width:28px; height:48px;" />
                </div>

                <div v-show="paginationBulletsLength !== 1" class="swiper-next column center v-end">
                    <img :src="IconNext" style="display:block; width:28px; height:48px;" />
                </div>

                <div class="swiper-container" id="content3d-swiper">
                    <div class="swiper-wrapper">
                        <div v-for="(item, index) in list" class="swiper-slide content3d-swiper-slide" :key="index">
                            <!-- <div
                                class="swiper-item column f1 v-center relative secondary-bg"
                                :class="{ hover: index == activeIndex }"
                                style="position:absolute; top:0; right:15px; bottom:0; left:15px;"
                                @mouseover="activeIndex = index"
                                @mouseout="activeIndex = -1"
                            > -->
                            <div class="swiper-item column f1 v-center relative secondary-bg hover"
                                style="position:absolute; top:0; right:15px; bottom:0; left:15px;"
                                @mouseover="activeIndex = index" @mouseout="activeIndex = -1">
                                <div style="position:absolute; width:100%; height: 100%; z-index:2;">
                                    <img :src="item.cover" class="card-photo" />
                                </div>
                                <div class="desc px-lg py-lg column">
                                    <div class="h4 mb-md">{{ item.name }}</div>
                                    <!-- <div
                                        v-show="index == activeIndex"
                                        class="t6"
                                        v-html="item.summary"
                                    ></div> -->
                                    <div class="t6" v-html="item.summary"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="paginationBulletsLength !== 1" class="mt-xxl row v-center center" style="height:16px;">
                        <div class="swiper-pagination222"></div>
                    </div>
                </div>
            </div>
            <!-- SWIPER END -->
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';

import {
    IconPrev,
	PlusRedIcon,
    IconNext,
    PlusWhiteIcon,
    Arrow,
    Circle,
    Hardware01,
    Hardware02,
    Hardware03,
    Hardware04,
} from '@/constants/pics';

export default {
    name: 'content3d',

    props: [],

    components: {},

    data() {
        return {
            swiper: null,

            IconPrev,
            IconNext,
            PlusWhiteIcon,
PlusRedIcon,
            Arrow,
            Circle,

            currentItem: 0,
            activeIndex: -1,

            list: [
                {
                    cover: Hardware01,
                    name: '婚庆典礼',
                    summary:
                        '通过大屏与手机的联动，我们将传统的观礼宾客变为婚礼的积极参与者。无论是发送弹幕祝福、参与游戏赢取喜悦，还是共同创造精彩瞬间，都能让婚礼的每一个环节都充满温馨、欢笑与感动，成为新人与宾客一生珍藏的浪漫回忆。',
                },
                {
                    cover: Hardware02,
                    name: '企业年会',
                    summary:
                        '通过科技感十足的互动游戏和即时抽奖，彻底打破传统年会的沉闷。它能有效增强员工参与感与团队凝聚力，在欢声笑语中彰显企业文化，激励员工士气，让年会成为一场展现公司实力与关怀的精彩盛宴。',
                }
            ],
        };
    },

    computed: {
        paginationBulletsLength() {
            if (!this.swiper) {
                return 1;
            }

            return this.swiper.pagination.bullets.length;
        },
    },

    created() { },

    mounted() {
        this.$nextTick(function () {
            this.initSwiper();
        });

        let resizeTag = true;
        window.addEventListener('resize', () => {
            if (resizeTag) {
                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                    // this.$nextTick(function() {
                    //     this.initSwiper();
                    // });
                }, 300);
            }
        });
    },

    activated() { },

    deactivated() { },

    methods: {
        onArtistClick() {
            const id = 'test';

            this.$router.push({ path: '/artist' });
        },

        lightbox() {
            this.showLightbox = true;
        },

        close() {
            this.showLightbox = false;
        },

        initSwiper() {
            this.swiper = new Swiper('#content3d-swiper', {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 0,

                slidesPerView: 'auto',
                threshold: 10,

                initialSlide: +this.currentItem,
                observer: true,
                observeParents: true,

                navigation: {
                    nextEl: '#content3d-swiper-wrap .swiper-next',
                    prevEl: '#content3d-swiper-wrap .swiper-prev',
                },

                pagination: {
                    el: '.swiper-pagination222',
                    clickable: true,
                },

                breakpoints: {
                    // when window width is >= 480px
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    479: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    480: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 720px
                    719: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    720: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1279: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1280: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1392: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    5120: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                },
            });

            if (this.swiper) {
                this.swiper.on(
                    'slideChange',
                    () => {
                        this.currentItem = this.swiper.activeIndex;
                    },
                );
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all';

.content3d-area {
    background: linear-gradient(to right, rgba(255, 51, 85, 1) 0%, rgba(241, 53, 54, 1) 100%);
    overflow: hidden;
}

// swiper-item
.swiper-container {
    width: 100%;
  
}

.swiper-slide {
   
    text-align: center;
    font-size: 18px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;

    position: relative;
}

.swiper-slide:after {
    content: '';
    position: relative;
 margin-top: 66.25%;
}

.swiper-next,
.swiper-prev {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 10;
    cursor: pointer;
    color: #333;
    width: 64px;
    height: auto;
    border-radius: 12px;
    border-radius: 0;
    will-change: transform;
    transition: all 300ms;
    outline: none;
}

.swiper-next:hover,
.swiper-prev:hover {
    width: 64px;
}

.swiper-next {
    right: -64px;
    left: auto;
    border-radius: 0;
    border-right: 0;
}

.swiper-prev {
    left: -64px;
    right: auto;
    border-radius: 0;
    border-left: 0;
}

//
//
//
a.more {
    color: #666;
    text-decoration: none;
}

// content3d-cover
.content3d-cover {
    background: rgba(127, 127, 127, 0.1);
    overflow: hidden;
}

.content3d-cover:after {
    content: '';
    position: relative;
    margin-top: 100%;
}

.content3d-cover a {
    display: block;
    width: 240px;
    height: 380px;
}

@media (max-width: 991px) {
    .content3d-title {
        padding: 0 15px;
    }

    .h1 {
        font-size: 24px;
    }

    .scroll-wrap {
        width: 100%;
        height: auto;
        overflow-x: auto;
        overflow-y: hidden;
    }

    .scroll-wrap .b-row {
        width: 1085px;
    }

    .b-container {
        padding-left: 0;
        padding-right: 0;
    }

    .b-row {
        margin-left: 0;
        margin-right: 0;
    }

    .company-item-wrap {
        flex: 0 0 320px;
    }

    .company-item {
        width: 240px;
        height: 380px;
    }

    a.more {
        font-size: 16px;
    }

    .title {
        font-size: 16px;
    }

    .summary {
        font-size: 16px;
    }
}

.swiper-item {
    overflow: hidden;
}

.swiper-item .desc {
    will-change: transform;
    transition: all 300ms;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 80px;
    z-index: 3;
    background: rgba(255, 255, 255, 0.88);
    text-align: left;
}

.swiper-item.hover .desc {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 196px;
    z-index: 3;
    color: #fff;
    // background: linear-gradient(to bottom, rgba(255, 51, 85, 0.8) 0%, rgba(241, 53, 54, 0.9) 100%);
    background: rgba(0, 0, 0, 0.5);
}

.swiper-button-disabled img {
    opacity: 0.38;
}

.lightbox {
    display: none;
}

.lightbox.display {
    display: block;
}

.swiper-container-wrap {
    margin-left: -15px;
    margin-right: -15px;
}

@media (max-width: 991px) {
    .swiper-container-wrap {
        margin-left: 0;
        margin-right: 0;
    }
}

//
.swiper-pagination .swiper-pagination-bullet-active {
    background: #ffffff !important;
}
</style>
